<!-- Spacer -->
<div
  class="ui-horizontal-navigation-item-wrapper"
  [ngClass]="item.classes?.wrapper"
></div>
